import React, { useState } from 'react';
import { Tabs, Tab, Box, Typography, Container } from "@mui/material";
import BasicInfoPage from './BasicInfoPage'; // Assuming this is the old company page component
import EmployeeList from './EmployeeList';
import FixedCostList from './FixedCostsList';
import VariableCostList from './VariableCostsList';

const CompanyPage = () => {

  const [tabIndex, setTabIndex] = useState(0);

  const handleTabChange = (event, newValue) => {
    setTabIndex(newValue);
  };

  return (
    <Box sx={{ width: "100%" }}>
       <Container maxWidth="md" sx={{ textAlign: "center" }}>
        <Typography variant="h3" fontWeight={700} gutterBottom>
          Cadastro da Empresa
        </Typography>
       </Container>
      <Tabs value={tabIndex} onChange={handleTabChange} centered>
        <Tab label="Dados Básicos" />
        <Tab label="Funcionários" />
        <Tab label="Custos Fixos" />
        <Tab label="Custos Variáveis" />
      </Tabs>

      <TabPanel value={tabIndex} index={0}>
        <BasicInfoPage />
      </TabPanel>

      <TabPanel value={tabIndex} index={1}>
        <EmployeeList />
      </TabPanel>

      <TabPanel value={tabIndex} index={2}>
        <FixedCostList />
      </TabPanel>

      <TabPanel value={tabIndex} index={3}>
        <VariableCostList />
      </TabPanel>
    </Box>
  );
};

export default CompanyPage;

function TabPanel({ children, value, index }) {
  return (
    <div role="tabpanel" hidden={value !== index}>
      {value === index && (
        <Box p={3}> 
          <Typography component="div">{children}</Typography>
        </Box>
      )}
    </div>
  );
}